
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/dialog-content",
      function () {
        return require("private-next-pages/joy-ui/api/dialog-content.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/dialog-content"])
      });
    }
  